import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Est-ce que je dois être expert en IA ?',
  a: 'Non. Les prompts sont conçus pour être copiés, personnalisés et utilisés avec les principaux assistants IA.'
}, {
  q: 'Est-ce que je dois savoir programmer ?',
  a: 'Absolument pas. Il s’agit d’instructions prêtes à copier-coller.'
}, {
  q: 'Quels outils IA puis-je utiliser ?',
  a: 'Le système est conçu pour fonctionner avec les principaux assistants IA tels que ChatGPT, Claude, Gemini et DeepSeek.'
}, {
  q: 'Est-ce un abonnement ?',
  a: 'Non. Il s’agit d’un paiement unique avec accès à vie au produit numérique.'
}, {
  q: 'Puis-je utiliser les prompts sur mobile ?',
  a: 'Oui. Les ressources sont conçues pour être consultables depuis un ordinateur, une tablette ou un smartphone.'
}, {
  q: 'Est-ce que l’IA remplace mon expertise professionnelle ?',
  a: 'Non. SIGMA SMART™ est un système d’assistance à la rédaction et à la structuration. Les informations produites par l’IA doivent toujours être relues, vérifiées et validées par le professionnel avant utilisation.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Questions fréquentes" className="bg-transparent" data-id="element-44" data-mp="1foncvvd5z7te">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-45" data-mp="1fqqcn744cfbb">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-46" data-mp="11v5wgjfryb7l">
          ❓ Questions fréquentes
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-47" data-mp="rzkuglaphaxu">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-48" data-mp="iymse8jtvdhw" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-49" data-mp="izfqkl4q0uof">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-50" data-mp="2kuvmuafhgylm">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-blush" data-id="element-51" data-mp="2fxvgdyeq1ttz" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-52" data-mp="2fuhaig6un2hs" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-53" data-mp="2avwd0oizewx1">
                  <div className="overflow-hidden" data-id="element-54" data-mp="33mxvayhz18ks">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-55" data-mp="2yn1s31h3ll6a">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}